import { useEffect, useState } from 'react';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { useNavigate, Link } from 'react-router-dom';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, {
  PaginationTotalStandalone,
  PaginationProvider,
  PaginationListStandalone
} from 'react-bootstrap-table2-paginator';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Alert, Spinner, Button } from 'react-bootstrap';
import Badge from 'components/base/Badge';
import FilterTab from 'components/common/FilterTab';
import useAdvanceTable from 'hooks/useAdvanceTable';
import FeatherIcon from 'feather-icons-react';
import { CustomSortCaret } from 'helpers/ui-utils';
import { getDischarged, searchItemMetadata } from 'api/api';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import DownloadButton from 'helpers/download-utils-inventory-discrepancy';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import moment from 'moment';

const DischargedReport = () => {
  const animatedComponents = makeAnimated();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [error, setError] = useState([]);
  const [total, setTotal] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [sortColumn, setSortColumn] = useState('asc');
  const [columnName, setColumnName] = useState('item.id');
  const [downLoadData, setDownLoadData] = useState([]);
  const [sortString, setSortString] = useState('added_time:desc');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [clearButtonVisibility, setClearButtonVisibility] = useState(false);
  const [makes, setMakes] = useState([]);
  const [selectedMake, setSelectedMake] = useState(null);

  useEffect(() => {
    loadData(currentPage, pageSize, sortString, null, null, null);
  }, []);

  useEffect(() => {
    loadDownLoadData();
  }, []);

  useEffect(() => {
    loadMakes();
  }, []);

  const loadData = (pageNr, pageSize, sortBy, fromDate, toDate, make) => {
    setError([]);
    setLoading(true);
    setData([]);

    fromDate = fromDate === null ? null : moment(fromDate).format('YYYY-MM-DD');
    toDate = toDate === null ? null : moment(toDate).format('YYYY-MM-DD');

    getDischarged(pageNr, pageSize, sortBy, fromDate, toDate, make)
      .then(response => {
        setTotal(response.data.data.total);
        if (response.data.data.data.length > 0) {
          const flattenedData = response.data.data.data.map(item => ({
            id: item.id,
            name: item.item.name,
            item_id: item.id,
            sku: item.item.sku,
            description:
              item.item.description === null ? '' : item.item.description,
            // serial_number: item.stock.serial_number,
            category: item.item.category.name,
            quantity: item.quantity,
            returned_quantity:
              item.returned_quantity !== undefined ? item.returned_quantity : 0,
            parent_category: item.item.category.parent_category.name,
            barcode: item.item.barcode && item.item.barcode.slice(-8),
            location: item.item.container.location.name,
            container: item.item.container.name,
            status: item.status.name,
            image: item.item.image,
            // stock_id: item.stock.id,
            last_access_time:
              item.added_time === null
                ? ''
                : moment(item.added_time).format('MM-DD-YYYY HH:mm'),
            last_access_user:
              item.user !== null &&
              `${item.user.first_name} ${item.user.last_name}`
          }));

          setData(flattenedData);
        }
      })
      .catch(err => {
        try {
          if (err.response.status === 401) {
            navigate('/sign-in');
          }
          setError(err.response.data.errors);
        } catch (ex) {
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  const loadDownLoadData = (startDate, endDate, make) => {
    setError([]);
    setDownLoadData([]);
    startDate =
      startDate === null ? null : moment(startDate).format('YYYY-MM-DD');
    endDate = endDate === null ? null : moment(endDate).format('YYYY-MM-DD');

    getDischarged(1, 0, 'added_time:desc', startDate, endDate, make)
      .then(response => {
        console.log(response.data.data.total);
        if (response.data.data.data.length > 0) {
          const flattenedData = response.data.data.data.map(item => ({
            make: item.item.name,
            category: item.item.category.name,
            container: item.item.container.name,
            quantity: item.quantity,
            returned_quantity:
              item.returned_quantity !== undefined ? item.returned_quantity : 0,
            checked_out_user:
              item.user !== null &&
              `${item.user.first_name} ${item.user.last_name}`,
            checked_out_time:
              item.added_time === null
                ? ''
                : moment(item.added_time).format('MM-DD-YYYY HH:mm'),
            status: item.status.name
          }));
          setDownLoadData(flattenedData);
        }
      })
      .catch(err => {
        try {
          if (err.response.status === 401) {
            navigate('/sign-in');
          }
          setError(err.response.data.errors);
        } catch (ex) {
          setError(['Please try again later...']);
        }
      });
  };

  const loadMakes = () => {
    searchItemMetadata('make')
      .then(response => {
        setMakes(response.data.data.make);
      })
      .catch(err => {
        try {
          setError(err.response.data.errors);
        } catch (error) {
          setError(['Please try again later...']);
        }
      });
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const CustomSortCaretUpdatedByOrder = (order, dataField) => {
    if (columnName === 'item.id')
      return (
        <span className="custom-sort-cart">
          <div style={{ display: 'inline-block' }}>
            ▲
            <br />▼
          </div>
        </span>
      );
    else if (sortColumn === 'asc')
      return (
        <span className="custom-sort-cart">
          <div style={{ display: 'inline-block' }}>
            <div style={{ display: 'inline-block' }}> ▲ </div>
            <br />
            <div style={{ display: 'inline-block', visibility: 'collapse' }}>
              ▼
            </div>
          </div>
        </span>
      );
    else if (sortColumn === 'desc')
      return <span className="custom-sort-cart">▼</span>;
    return null;
  };

  const columns = [
    {
      dataField: 'image',
      formatter: (cellContent, row) => (
        <Link
          to={`/weapons/weapon-details/${row.item_id}`}
          className="rounded-2 border d-inline-block"
        >
          <img src={row.image} alt="" width={53} />
        </Link>
      ),
      headerStyle: () => ({ width: '80px' })
    },
    {
      dataField: 'name',
      text: 'MAKE',
      headerStyle: { width: '15%', fontSize: '13px' },
      sort: true,
      sortCaret:
        columnName === 'name' ? CustomSortCaretUpdatedByOrder : CustomSortCaret,
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
        color: 'phoenix-gray-1100'
      },
      formatter: (cell, row) => {
        return (
          <>
            <Link
              to={`/weapons/weapon-details/${row.item_id}`}
              className="fw-semi-bold line-clamp-3"
            >
              {row.name}
            </Link>
          </>
        );
      }
    },
    // {
    //   dataField: 'description',
    //   text: 'MODEL',
    //   headerStyle: { width: '10%', fontSize: '13px' },
    //   sort: true,
    //   sortCaret:
    //     columnName === 'description'
    //       ? CustomSortCaretUpdatedByOrder
    //       : CustomSortCaret,
    //   style: {
    //     fontSize: '12px',
    //     color: 'phoenix-gray-1100'
    //   },
    //   formatter: (cell, row) => {
    //     return <> {row.description}</>;
    //   }
    // },
    {
      dataField: 'category',
      text: 'CATEGORY',
      headerStyle: { width: '10%', fontSize: '13px' },
      sort: true,
      sortCaret:
        columnName === 'category'
          ? CustomSortCaretUpdatedByOrder
          : CustomSortCaret,
      style: {
        fontSize: '12px',
        color: 'phoenix-gray-1100'
      },
      formatter: (cell, row) => {
        return <> {row.category}</>;
      }
    },

    // {
    //   dataField: 'sku',
    //   text: 'CALIBRE',
    //   headerStyle: { width: '10%', fontSize: '13px' },
    //   sort: true,
    //   sortCaret:
    //     columnName === 'sku' ? CustomSortCaretUpdatedByOrder : CustomSortCaret,
    //   style: {
    //     fontSize: '12px',
    //     fontWeight: 'bold',
    //     color: 'phoenix-gray-1100'
    //   },
    //   formatter: (cell, row) => {
    //     return <>{row.sku}</>;
    //   }
    // },
    // {
    //   dataField: 'epc',
    //   text: 'EPC',
    //   headerStyle: { width: '8%', fontSize: '13px' },
    //   sort: true,
    //   sortCaret:
    //     columnName === 'epc' ? CustomSortCaretUpdatedByOrder : CustomSortCaret,
    //   style: {
    //     fontSize: '12px',
    //     fontWeight: 'bold',
    //     color: 'phoenix-gray-1100'
    //   }
    // },
    {
      dataField: 'container',
      text: 'CONTAINER',
      headerStyle: { width: '12%', fontSize: '13px' },
      sort: true,
      sortCaret:
        columnName === 'container'
          ? CustomSortCaretUpdatedByOrder
          : CustomSortCaret,
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
        color: 'phoenix-gray-1100'
      },
      formatter: (cell, row) => {
        return <>{row.container}</>;
      }
    },
    {
      dataField: 'quantity',
      text: 'Qty',
      headerStyle: { width: '5%', fontSize: '13px' },
      sort: true,
      sortCaret:
        columnName === 'quantity'
          ? CustomSortCaretUpdatedByOrder
          : CustomSortCaret,
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
        color: 'phoenix-gray-1100'
      },
      formatter: (cell, row) => {
        return <>{row.quantity}</>;
      }
    },
    {
      dataField: 'returned_quantity',
      text: 'Return Qty',
      headerStyle: { width: '10%', fontSize: '13px' },
      sort: true,
      sortCaret:
        columnName === 'returned_quantity'
          ? CustomSortCaretUpdatedByOrder
          : CustomSortCaret,
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
        color: 'phoenix-gray-1100'
      },
      formatter: (cell, row) => {
        return <>{row.returned_quantity}</>;
      }
    },
    {
      dataField: 'last_access_user',
      text: 'CHECKOUT USER',
      headerStyle: { width: '15%', fontSize: '13px' },
      sort: true,
      sortCaret:
        columnName === 'last_access_user'
          ? CustomSortCaretUpdatedByOrder
          : CustomSortCaret,
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
        color: 'phoenix-gray-1100'
      },
      formatter: (cell, row) => {
        return <>{row.last_access_user}</>;
      }
    },

    {
      dataField: 'last_access_time',
      text: 'CHECKOUT TIME',
      headerStyle: { width: '15%', fontSize: '13px' },
      sort: true,
      sortCaret:
        columnName === 'last_access_time'
          ? CustomSortCaretUpdatedByOrder
          : CustomSortCaret,
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
        color: 'phoenix-gray-1100'
      },
      formatter: (cell, row) => {
        return <>{row.last_access_time}</>;
      }
    },

    {
      dataField: 'status',
      text: 'STATUS',
      sort: true,
      sortCaret:
        columnName === 'status'
          ? CustomSortCaretUpdatedByOrder
          : CustomSortCaret,
      headerStyle: { fontSize: '13px' },
      style: {
        fontSize: '12px',
        color: 'phoenix-gray-1100'
      },
      formatter: (cell, row) => {
        if (
          (row.status && row.status.toLowerCase() === 'checked out') ||
          (row.status && row.status.toLowerCase() === 'in stock') ||
          (row.status && row.status.toLowerCase() === 'enrolled')
        ) {
          return (
            <Badge
              bg={'success'}
              variant="phoenix"
              iconPosition="end"
              className="fs-10"
              icon={<FeatherIcon icon={'check'} size={12} className="ms-1" />}
            >
              {row.status}
            </Badge>
          );
        } else {
          return (
            <Badge
              bg={'danger'}
              variant="phoenix"
              iconPosition="end"
              className="fs-10"
              icon={<FeatherIcon icon={'info'} size={12} className="ms-1" />}
            >
              {row.status}
            </Badge>
          );
        }
      }
    }
  ];

  const handleAllClick = () => {
    setSortString('added_time:desc');
    setCurrentPage(1);
    loadData(1, 10, 'added_time:desc');
    loadDownLoadData();
  };

  const tabItems = [
    {
      label: 'All Weapons',
      value: 'all',
      count: total,
      onClick: handleAllClick
    }
  ];

  const table = useAdvanceTable({
    data: data
  });

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    switch (type) {
      case 'pagination':
        pagination(page, sizePerPage);
        break;
      case 'sort':
        sort(sortField, sortOrder, data);
        break;
      default:
        break;
    }
  };

  const handleLoadData = () => {
    setCurrentPage(1);
    setClearButtonVisibility(true);

    loadData(
      1,
      10,
      'added_time:desc',
      startDate === null ? null : moment(startDate).format('YYYY-MM-DD'),
      endDate === null ? null : moment(endDate).format('YYYY-MM-DD'),
      selectedMake === null ? null : selectedMake.value
    );

    loadDownLoadData(
      startDate === null ? null : moment(startDate).format('YYYY-MM-DD'),
      endDate === null ? null : moment(endDate).format('YYYY-MM-DD'),
      selectedMake === null ? null : selectedMake.value
    );
  };

  const handleClearFilters = () => {
    setCurrentPage(1);
    setStartDate(null);
    setEndDate(null);
    setSelectedMake(null);
    setClearButtonVisibility(false);
    loadData(currentPage, pageSize, 'added_time:desc', null, null);
    loadDownLoadData(null, null);
  };

  const pagination = (page, sizePerPage) => {
    setCurrentPage(page);
    setPageSize(sizePerPage);
    loadData(page, sizePerPage, sortString);
  };

  const sort = sortField => {
    setCurrentPage(1);
    if (sortColumn === 'desc') {
      setSortColumn('asc');
    } else if (sortColumn === 'asc') {
      setSortColumn('desc');
    }
    switch (sortField) {
      case 'name':
        setColumnName('name');
        setSortString(`item.name:${sortColumn}`);
        loadData(
          1,
          10,
          `item.name:${sortColumn}`,
          startDate === null ? null : moment(startDate).format('YYYY-MM-DD'),
          endDate === null ? null : moment(endDate).format('YYYY-MM-DD'),
          selectedMake === null ? null : selectedMake.value
        );
        break;
      case 'sku':
        setColumnName('sku');
        setSortString(`item.sku:${sortColumn}`);
        loadData(
          1,
          10,
          `item.sku:${sortColumn}`,
          startDate === null ? null : moment(startDate).format('YYYY-MM-DD'),
          endDate === null ? null : moment(endDate).format('YYYY-MM-DD'),
          selectedMake === null ? null : selectedMake.value
        );
        break;
      case 'description':
        setColumnName('description');
        setSortString(`item.description:${sortColumn}`);
        loadData(
          1,
          10,
          `item.description:${sortColumn}`,
          startDate === null ? null : moment(startDate).format('YYYY-MM-DD'),
          endDate === null ? null : moment(endDate).format('YYYY-MM-DD'),
          selectedMake === null ? null : selectedMake.value
        );
        break;
      case 'epc':
        setColumnName('epc');
        setSortString(`epc:${sortColumn}`);
        loadData(
          1,
          10,
          `epc:${sortColumn}`,
          startDate === null ? null : moment(startDate).format('YYYY-MM-DD'),
          endDate === null ? null : moment(endDate).format('YYYY-MM-DD'),
          selectedMake === null ? null : selectedMake.value
        );
        break;
      case 'serial_number':
        setColumnName('serial_number');
        setSortString(`serial_number:${sortColumn}`);
        loadData(
          1,
          10,
          `serial_number:${sortColumn}`,
          startDate === null ? null : moment(startDate).format('YYYY-MM-DD'),
          endDate === null ? null : moment(endDate).format('YYYY-MM-DD'),
          selectedMake === null ? null : selectedMake.value
        );
        break;
      case 'parent_category':
        setColumnName('parent_category');
        setSortString(`item.item_category.item_category.name:${sortColumn}`);
        loadData(
          1,
          10,
          `item.item_category.item_category.name:${sortColumn}`,
          startDate === null ? null : moment(startDate).format('YYYY-MM-DD'),
          endDate === null ? null : moment(endDate).format('YYYY-MM-DD'),
          selectedMake === null ? null : selectedMake.value
        );
        break;
      case 'category':
        setColumnName('category');
        setSortString(`item.item_category.name:${sortColumn}`);
        loadData(
          1,
          10,
          `item.item_category.name:${sortColumn}`,
          startDate === null ? null : moment(startDate).format('YYYY-MM-DD'),
          endDate === null ? null : moment(endDate).format('YYYY-MM-DD'),
          selectedMake === null ? null : selectedMake.value
        );
        break;
      case 'quantity':
        setColumnName('quantity');
        setSortString(`quantity:${sortColumn}`);
        loadData(
          1,
          10,
          `quantity:${sortColumn}`,
          startDate === null ? null : moment(startDate).format('YYYY-MM-DD'),
          endDate === null ? null : moment(endDate).format('YYYY-MM-DD'),
          selectedMake === null ? null : selectedMake.value
        );
        break;
      case 'returned_quantity':
        setColumnName('returned_quantity');
        setSortString(`returned_quantity:${sortColumn}`);
        loadData(
          1,
          10,
          `returned_quantity:${sortColumn}`,
          startDate === null ? null : moment(startDate).format('YYYY-MM-DD'),
          endDate === null ? null : moment(endDate).format('YYYY-MM-DD'),
          selectedMake === null ? null : selectedMake.value
        );
        break;
      case 'location':
        setColumnName('location');
        setSortString(`container.location.name:${sortColumn}`);
        loadData(
          1,
          10,
          `container.location.name:${sortColumn}`,
          startDate === null ? null : moment(startDate).format('YYYY-MM-DD'),
          endDate === null ? null : moment(endDate).format('YYYY-MM-DD'),
          selectedMake === null ? null : selectedMake.value
        );
        break;
      case 'container':
        setColumnName('container');
        setSortString(`item.container.name:${sortColumn}`);
        loadData(
          1,
          10,
          `item.container.name:${sortColumn}`,
          startDate === null ? null : moment(startDate).format('YYYY-MM-DD'),
          endDate === null ? null : moment(endDate).format('YYYY-MM-DD'),
          selectedMake === null ? null : selectedMake.value
        );
        break;
      case 'last_access_time':
        setColumnName('last_access_time');
        setSortString(`added_time:${sortColumn}`);
        loadData(
          1,
          10,
          `added_time:${sortColumn}`,
          startDate === null ? null : moment(startDate).format('YYYY-MM-DD'),
          endDate === null ? null : moment(endDate).format('YYYY-MM-DD'),
          selectedMake === null ? null : selectedMake.value
        );
        break;
      case 'last_access_user':
        setColumnName('last_access_user');
        setSortString(`user.first_name:${sortColumn}`);
        loadData(
          1,
          10,
          `user.first_name:${sortColumn}`,
          startDate === null ? null : moment(startDate).format('YYYY-MM-DD'),
          endDate === null ? null : moment(endDate).format('YYYY-MM-DD'),
          selectedMake === null ? null : selectedMake.value
        );
        break;
      case 'status':
        setColumnName('status');
        setSortString(`status.name:${sortColumn}`);
        loadData(
          1,
          10,
          `status.name:${sortColumn}`,
          startDate === null ? null : moment(startDate).format('YYYY-MM-DD'),
          endDate === null ? null : moment(endDate).format('YYYY-MM-DD'),
          selectedMake === null ? null : selectedMake.value
        );
        break;

      default:
        break;
    }
  };

  const customStyles = {
    control: provided => ({
      ...provided,
      fontSize: '12px'
    }),
    placeholder: provided => ({
      ...provided,
      fontSize: '12px'
    })
  };
  const handleChangeMake = selected => {
    setSelectedMake(selected);
  };

  return (
    <div>
      <div className="mb-9">
        <div>
          <h2 className="mb-2">Discrepancy Report</h2>
          {/* <h5 className="text-700 fw-semi-bold">
            {`The weapons that were not returned are shown below.`}
          </h5> */}
        </div>

        <FilterTab tabItems={tabItems} className="mb-2" />

        <AdvanceTableProvider {...table}>
          <div className="mb-4">
            <div className="d-flex flex-wrap gap-3">
              <div style={{ width: '180px' }}>
                <Select
                  classNamePrefix="react-select"
                  closeMenuOnSelect={true}
                  components={animatedComponents}
                  options={
                    makes &&
                    makes.map(c => ({
                      value: c,
                      label: c
                    }))
                  }
                  placeholder={'Select make'}
                  styles={customStyles}
                  value={selectedMake}
                  onChange={e => handleChangeMake(e)}
                  required
                  name="make"
                  menuPlacement="auto"
                />
              </div>

              <div className="scrollbar overflow-hidden-y">
                <DatePicker
                  selected={startDate}
                  onChange={date => setStartDate(date)}
                  placeholder="Start Date"
                  className="form-control"
                  placeholderText="Select start date"
                  dateFormat="MM-dd-yyyy"
                />
              </div>

              <div className="scrollbar overflow-hidden-y">
                <DatePicker
                  selected={endDate}
                  onChange={date => setEndDate(date)}
                  className="form-control"
                  placeholderText="Select end date"
                  dateFormat="MM-dd-yyyy"
                />
              </div>

              <div className="scrollbar overflow-hidden-y">
                <Button
                  variant="primary"
                  type="button"
                  onClick={() => handleLoadData()}
                >
                  Load Data
                </Button>
              </div>

              <div className="scrollbar overflow-hidden-y">
                <Button
                  variant="phoenix-secondary"
                  style={{
                    visibility:
                      clearButtonVisibility === true ? 'visible' : 'hidden'
                  }}
                  onClick={() => handleClearFilters()}
                >
                  Clear Filters
                </Button>
              </div>

              <div className="ms-xxl-auto">
                <DownloadButton
                  data={downLoadData}
                  info={`The items that were not returned are shown below.`}
                  allCount={total}
                />
              </div>
            </div>
          </div>

          <div>
            {Object.entries(error).length > 0 &&
              error.map((e, index) => (
                <Alert variant="soft-danger" key={index}>
                  {e}
                </Alert>
              ))}
          </div>

          <div className="bg-white border-top border-bottom border-200 position-relative top-1">
            {loading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: '200px' }}
              >
                <Spinner animation="border" role="status"></Spinner>
              </div>
            ) : (
              <PaginationProvider
                pagination={paginationFactory({
                  custom: true,
                  page: currentPage,
                  sizePerPage: pageSize,
                  totalSize: total,
                  sizePerPageList: [
                    {
                      text: '10',
                      value: 10
                    }
                  ]
                })}
              >
                {({ paginationProps, paginationTableProps }) => (
                  <div>
                    <BootstrapTable
                      remote
                      keyField="id"
                      data={data.length === 0 ? [] : data}
                      columns={columns}
                      bordered={false}
                      onTableChange={handleTableChange}
                      {...paginationTableProps}
                    />
                    <div>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginTop: '-10px',
                          fontSize: '13px'
                        }}
                      >
                        <PaginationTotalStandalone {...paginationProps} />
                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    </div>
                  </div>
                )}
              </PaginationProvider>
            )}
          </div>
        </AdvanceTableProvider>
      </div>
    </div>
  );
};

export default DischargedReport;
